import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'memory'
})
export class MemoryPipe implements PipeTransform {

  transform(value: string, args?: any): string {
    const _val = Number(value);
    if (!_val) {
      return '';
    }
    return _val >= 1024 ? `${ _val / 1024 } Gb` : `${ _val } Mb`;
  }

}
